import { NgFor, NgIf } from '@angular/common';
import { Component, Input, OnChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTableModule } from '@angular/material/table';
import { LocalUseField } from './models/LocalUseField.model';
import { LocalUseResponse } from './models/LocalUseResponse.model';
import { LocalUseService } from './services/local-use.service';
import { NgForTrackByItemDirective } from '../../directives/ng-for-track-by-id.directive';

@Component({
    selector: 'local-use-data-entry',
    templateUrl: './local-use-data-entry.component.html',
    styleUrls: ['./local-use-data-entry.component.less'],
    standalone: true,
    imports: [
        NgFor,
        NgForTrackByItemDirective,
        MatTableModule,
        NgIf,
        FormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatAutocompleteModule,
        MatOptionModule,
        MatButtonModule,
        MatIconModule,
    ],
})
export class LocalUseDataEntryComponent implements OnChanges {
	@Input() entityType: string;
	@Input() entityId: string;
	@Input() groupFilter = '';
	@Input() readOnly = false;

	fields: LocalUseField[];
	groups: string[] = [];
	dirty = false;
	errors: string[] = [];
	initComplete = false;
	mustReload = false;
	isDirty = false;

	constructor(private readonly service: LocalUseService) {}

	ngOnChanges(): void {
		this.initializeControl();
	}

	initializeControl(): void {
		if (this.entityId !== null && this.entityId !== undefined && !this.initComplete) {
			this.isDirty = false;
			this.initComplete = true;

			this.service.getEntityData(this.entityType, this.entityId, this.groupFilter).subscribe((data: LocalUseResponse) => {
				this.initializeLocalUseFields(data);
			});
		}
	}
	clearField(field: LocalUseField): void {
		field.FieldValue = null;
		this.isDirty = true;
	}

	initializeLocalUseFields(data: LocalUseResponse): void {
		this.fields = [];
		let tempField: LocalUseField;

		data.fields.forEach((field) => {
			if (field) {
				tempField = new LocalUseField(field);

				this.fields.push(tempField);
				if (!this.groups.includes(tempField.GroupName)) {
					this.groups.push(tempField.GroupName);
				}
			}
		});
		this.groups.sort();
	}

	getFieldsByGroup(groupName: string): LocalUseField[] {
		return this.fields.filter((f) => f.GroupName === groupName);
	}

	loadLocalUse(): void {
		this.initComplete = false;
		this.initializeControl();
	}

	save(): void {
		this.errors = [];

		if (this.isDirty) {
			this.service.postEntityData(this.fields).subscribe((data: LocalUseResponse) => {
				this.finishedSavingItem(data);
			});
		}
	}

	finishedSavingItem(response: LocalUseResponse): void {
		if (!response.isValid) {
			this.errors.push(`Error: ${response.error}`);
			this.mustReload = true;
		}
		this.loadLocalUse();
	}

	fieldChanged(): void {
		this.isDirty = true;
	}

	cancelChanges(): void {
		this.fields.forEach((currentField) => {
			currentField.FieldValue = currentField.OriginalFieldValue;
		});

		this.errors = [];
		this.isDirty = false;
	}

	public valuesListTrackByFn(index: number): number {
		return index;
	}
}
